import type { ItemPriority } from '@hugo/core'

/** The priorities as the details sheet offers them, with what each does. */
export const PRIORITY_CHOICES: readonly { value: ItemPriority; label: string; hint: string }[] = [
  {
    value: 'high',
    label: 'High',
    hint: 'hugo does it first, as long as nothing with a date gets late',
  },
  { value: 'normal', label: 'Normal', hint: 'hugo plans it by its due date' },
  { value: 'low', label: 'Low', hint: 'hugo does it after other work, where there is room' },
]

/** "High", "Normal", "Low". */
export function priorityLabel(priority: ItemPriority): string {
  return PRIORITY_CHOICES.find((choice) => choice.value === priority)?.label ?? 'Normal'
}

/** Rows and cards mark high and low; normal is the default and shows nothing. */
export const showsPriority = (priority: ItemPriority): boolean => priority !== 'normal'
